import { createApp } from '@backstage/frontend-defaults';
import apiDocsPlugin from '@backstage/plugin-api-docs/alpha';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import scaffolderPlugin from '@backstage/plugin-scaffolder/alpha';
import {
  factoryPortalAuthModule,
  factoryPortalPlugin,
} from './modules/factoryPortal';
import { factoryPortalBackstageFeatures } from './modules/backstageOfficialPlugins';
import { navModule } from './modules/nav';

export const factoryPortalFeatures = [
  apiDocsPlugin,
  catalogPlugin,
  scaffolderPlugin,
  ...factoryPortalBackstageFeatures,
  navModule,
  factoryPortalPlugin,
  factoryPortalAuthModule,
];

export default createApp({
  features: factoryPortalFeatures,
});
